export default __webpack_public_path__ + "static/media/twitter-grey.9219034d.svg";